<template>
  <div class="npa-bill">
    <Search/>
    <v-container>
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs"/>
      </div>
      <div class="position">
        <div
          class="tabs-main"
          v-if="
                data.refInitiator &&
                  menu.npa_view_type &&
                  menu.npa_view_type.id === 1
              "
        >
          <div class="v-tabs-main">
            <mq-layout mq="laptop">
              <a
                href="#"
                class="btn-column-list"
                :aria-label="showBlock ? $t('Показать списком') : $t('Показать плиткой')"
                @click.prevent="showBlock = !showBlock"
              >
                <v-icon x-large v-if="showBlock" aria-hidden="true">mdi-view-list</v-icon>
                <v-icon x-large v-else aria-hidden="true">mdi-view-module</v-icon>
              </a>
            </mq-layout>
            <v-tabs centered>
              <v-tab
                v-for="tab in data.refInitiator"
                :key="tab.id"
                :class="{ 'v-tab--active': tab.id === search.initiator }"
                @click="
                      clearSort(),
                        searchNPA(
                          tab.id,
                          tab.transName,
                          menu.npa_view_type.id,
                          true
                        )
                    "
              >
                {{ tab.transName }}
              </v-tab>
            </v-tabs>
          </div>
        </div>
        <div class="bg-white p-20">
          <div v-if="menu">
            <div
              class="filter-list"
              v-if="data.refNpaViewForNpaType && menu.npa_view_type && menu.npa_view_type.id === 2"
            >
              <ul>
                <li
                  v-for="tab in data.refNpaViewForNpaType"
                  :key="tab.id"
                  :class="{ active: tab.id === search.view }"
                >
                  <a href="#" @click.prevent="clearSort(),searchNPA(tab.id,tab.transName,menu.npa_view_type.id,true)">
                    {{ tab.transName }}
                  </a>
                </li>
              </ul>
              <div class="search-action">
                <v-row>
                  <mq-layout mq="laptop">
                    <v-col cols sm="12" md="1">
                        <a
                          href="#"
                          class="btn-column-list"
                          :aria-label="showBlock ? $t('Показать списком') : $t('Показать плиткой')"
                          @click.prevent="showBlock = !showBlock"
                        >
                          <v-icon x-large v-if="showBlock" aria-hidden="true">mdi-view-list</v-icon>
                          <v-icon x-large v-else aria-hidden="true">mdi-view-module</v-icon>
                        </a>
                    </v-col>
                  </mq-layout>
                  <v-col cols sm="12" md v-if="search.view === data.npaViewLocalResolution.id">
                    <v-select
                      :items="data.refRegions"
                      return-object
                      item-text="transName"
                      v-model="region"
                      :aria-label="$t('Область')"
                      :placeholder="$t('Область')"
                      required
                      outlined
                      dense
                      clearable
                    />
                  </v-col>
                  <v-col cols sm="12" md v-if="search.view === data.npaViewLocalResolution.id">
                    <v-select
                      v-if="region"
                      :items="region.districts"
                      item-value="id"
                      item-text="transName"
                      v-model="search.district"
                      :aria-label="$t('Район')"
                      :placeholder="$t('Район')"
                      required
                      outlined
                      dense
                    />
                    <v-select
                      v-else
                      :placeholder="$t('Область')"
                      :aria-label="$t('Район')"
                      disabled
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col class="form-action" cols sm="12" md v-if="search.view === data.npaViewLocalResolution.id">
                    <button
                      class="btn btn-default blue"
                      @click="clearSort(),searchNPA(data.npaViewLocalResolution.id,data.npaViewLocalResolution.transName,menu.npa_view_type.id,true)"
                    >
                      {{ $t('Поиск') }}
                    </button>
                    <button
                      class="btn btn-default white"
                      @click="(region = {}), (search = {}),clearSort(), searchNPA(data.npaViewLocalResolution.id,data.npaViewLocalResolution.transName,menu.npa_view_type.id,true)"
                    >
                      {{ $t('Очистить') }}
                    </button>
                  </v-col>
                </v-row>
              </div>
            </div>
            <div class="search-body">
              <div class="search-result">
                <div class="search-result-body">
                  <mq-layout mq="laptop">
                    <v-col cols="12" class="ml-n3" v-if="menu.npa_view_type.id !== 3">
                      <label>{{ $t(initiatorLabel) }}</label>
                      <div class="d-flex flex-column flex-md-row align-md-center">

                        <div class="select-def flex-grow-1" style="max-width: max-content" >
                          <v-select
                            @input="(e) => searchNPA(e)"
                            :items="initiatorItems"
                            item-value="id"
                            item-text="transName"
                            v-model="search.initiator"
                            :aria-label="$t(initiatorLabel)"
                            required
                            outlined
                            dense
                            clearable
                            hide-details
                          />
                        </div>
                        <router-link
                          v-if="$route.params.slug === 'zakonoproekty'"
                          class="text-no-wrap ml-md-4 mt-2 mt-md-0 btn btn-default text-white"
                          :title="$t('Законопроекты, инициированные депутатами ЖК')"
                          :to="$i18nRoute({name: 'LawList'})"
                        >
                          {{ $t('Законопроекты, инициированные депутатами ЖК') }}
                        </router-link>
                      </div>
                    </v-col>
                    <div class="type-column">
                      <v-simple-table v-if="!showBlock">
                        <template v-slot:default>
                          <thead>
                          <tr>
                            <th>
                              <a href="#" :aria-label="$t('Сортировать') + ': ' + $t('Вид проекта')" @click.prevent="sortData('view')">
                                <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i>{{ $t('Вид проекта') }}
                              </a>
                            </th>
                            <th>
                              <a href="#" :aria-label="$t('Сортировать') + ': ' + $t('Наименование')" @click.prevent="sortData('name')">
                                <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i>{{ $t('Наименование') }}
                              </a>
                            </th>
                            <th>
                              <a href="#" :aria-label="$t('Сортировать') + ': ' + $t('Комментарии')" @click.prevent="sortData('viewNumber')">
                                <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i>{{ $t('Комментарии') }}
                              </a>
                            </th>
                            <th>
                              <a href="#" :aria-label="$t('Сортировать') + ': ' + $t('Разработчик')" @click.prevent="sortData('developer')">
                                <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i>{{ $t('Разработчик') }}
                              </a>
                            </th>
                            <th>
                              <a href="#" :aria-label="$t('Сортировать') + ': ' + $t('Категории')" @click.prevent="sortData('category')">
                                <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i>{{ $t('Категории') }}
                              </a>
                            </th>
                            <th>
                              <a href="#" :aria-label="$t('Сортировать') + ': ' + $t('Инициатор')" @click.prevent="sortData('initiator')">
                                <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i>{{ $t('Инициатор') }}
                              </a>
                            </th>
                            <th>
                              <a href="#" :aria-label="$t('Сортировать') + ': ' + $t('Дата публикации')" @click.prevent="sortData('publishDate')">
                                <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i>{{ $t('Дата публикации') }}
                              </a>
                            </th>
                            <th>
                              <a href="#" :aria-label="$t('Сортировать') + ': ' + $t('Статус')" @click.prevent="sortData('status')">
                                <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i>{{ $t('Статус') }}
                              </a>
                            </th>
                            <th>
                              <a href="#" :aria-label="$t('Сортировать') + ': ' + $t('Дата окончания обсуждения')" @click.prevent="sortData('discussionPeriodDateTo')">
                                <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i> {{ $t('Дата окончания обсуждения') }}
                              </a>
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="item in result" :key="item.id">
                            <td>{{ item.view.transName }}</td>
                            <td>
                              <router-link
                                :title="item.transProjectGoal | strippedContent"
                                active-class="active"
                                :to="$i18nRoute({
                                      name: 'view-npa',
                                      params: { id: item.id }
                                    })"
                                :key="item.id"
                              >
                                {{ item.transName }}
                              </router-link>
                            </td>
                            <td>
                              <div class="analytics">
                                    <span class="views">
                                      <i class="pro-icon-eye" aria-hidden="true"></i>
                                      <span class="sr-only">{{ $t('Просмотры') }}: </span>
                                      {{ item.view_number }}
                                    </span>
                                <span class="comments">
                                      <i class="pro-icon-chat" aria-hidden="true"></i>
                                      <span class="sr-only">{{ $t('Комментарии') }}: </span>
                                      {{ commentsCnt[item.id].cntComments }}
                                    </span>
                                <span class="messages">
                                      <i class="pro-icon-speech-bubble" aria-hidden="true"></i>
                                      <span class="sr-only">{{ $t('Ответы') }}: </span>
                                      {{ answersCnt[item.id].cntAnswers }}
                                    </span>
                              </div>
                            </td>
                            <td>
                              <v-icon
                                v-if="item.developer.status === false"
                                class="nv_icon mr-1"
                                x-small
                                aria-hidden="true"
                              />
                              {{ item.developer.transName }}
                            </td>
                            <td>
                              <template v-for="(category, key) in item.category">
                                <span :key="category.id">
                                  <span v-if="key !== 0">, </span>{{ category.transName }}
                                </span>
                              </template>
                            </td>
                            <td>
                              {{ item.initiator.transName }}
                            </td>
                            <td>
                              {{ new Date(item.publish_date) | dateFormat('DD.MM.YYYY') }}
                            </td>
                            <td>{{ item.status.transName }}</td>
                            <td>
                              <span v-if="item.discussion_period_date_to">
                                {{
                                  new Date(item.discussion_period_date_to)
                                    | dateFormat('DD.MM.YYYY')
                                }}
                              </span>
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <div class="columns-item" v-else>
                        <v-row>
                          <v-col cols md="4" v-for="item in result" :key="item.id">
                            <div class="project-type">
                              {{ item.view.transName }}
                            </div>
                            <div class="npa-title">
                              <router-link
                                :title="item.transProjectGoal | strippedContent"
                                active-class="active"
                                :to="$i18nRoute({ name: 'view-npa', params: { id: item.id } })"
                                :key="item.id"
                              >
                                {{ item.transName | splitTextIntoLines(4, 30) }}
                              </router-link>
                            </div>
                            <div class="npa-dev">
                              <a href="#!">
                                <v-icon
                                  v-if="item.developer.status === false"
                                  class="nv_icon mr-1"
                                  x-small
                                  aria-hidden="true"
                                />
                                {{ item.developer.transName | splitTextIntoLines(2, 30) }}
                              </a>
                            </div>
                            <div class="date-period">
                              <p>{{ item.status.transName }}</p>
                              <p>
                                {{ $t('Дата окончания обсуждения') }}:
                                {{
                                new Date(item.discussion_period_date_to)
                                | dateFormat('DD.MM.YYYY')
                                }}
                              </p>
                            </div>
                            <div class="npa-analitics">
                              <div class="analytics">
                                  <span class="views">
                                    <i class="pro-icon-eye" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('Просмотры') }}: </span>
                                    {{ item.view_number }}
                                  </span>
                                <span class="comments">
                                    <i class="pro-icon-chat" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('Комментарии') }}: </span>
                                    {{ commentsCnt[item.id].cntComments }}
                                  </span>
                                <span class="messages">
                                    <i class="pro-icon-speech-bubble" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('Ответы') }}: </span>
                                    {{ answersCnt[item.id].cntAnswers }}
                                  </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </mq-layout>
                  <mq-layout mq="mobile">
                    <div class="columns-item">
                        <v-row>
                          <v-col cols md="4" v-for="item in result" :key="item.id">
                            <div class="project-type">
                              {{ item.view.transName }}
                            </div>
                            <div class="npa-title">
                              <router-link
                                :title="item.transProjectGoal | strippedContent"
                                active-class="active"
                                :to="$i18nRoute({ name: 'view-npa', params: { id: item.id } })"
                                :key="item.id"
                              >
                                {{ item.transName | splitTextIntoLines(4, 30) }}
                              </router-link>
                            </div>
                            <div class="npa-dev">
                              <a href="#!">
                                <v-icon
                                  v-if="item.developer.status === false"
                                  class="nv_icon mr-1"
                                  x-small
                                  aria-hidden="true"
                                />
                                {{ item.developer.transName | splitTextIntoLines(2, 30) }}
                              </a>
                            </div>
                            <div class="date-period">
                              <p>{{ item.status.transName }}</p>
                              <p>
                                {{ $t('Дата окончания обсуждения') }}:
                                {{
                                new Date(item.discussion_period_date_to)
                                | dateFormat('DD.MM.YYYY')
                                }}
                              </p>
                            </div>
                            <div class="npa-analitics">
                              <div class="analytics">
                                  <span class="views">
                                    <i class="pro-icon-eye" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('Просмотры') }}: </span>
                                    {{ item.view_number }}
                                  </span>
                                <span class="comments">
                                    <i class="pro-icon-chat" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('Комментарии') }}: </span>
                                    {{ commentsCnt[item.id].cntComments }}
                                  </span>
                                <span class="messages">
                                    <i class="pro-icon-speech-bubble" aria-hidden="true"></i>
                                    <span class="sr-only">{{ $t('Ответы') }}: </span>
                                    {{ answersCnt[item.id].cntAnswers }}
                                  </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                  </mq-layout>
                </div>
                <div class="search-result-footer">
                  <p>{{ $t('Общее количество НПА') }}: {{ paginationData.totalCount }}</p>
                </div>
              </div>
              <v-pagination
                v-model="page"
                :length="paginationData.pageCount"
                :aria-label="$t('Страницы результатов поиска')"
                total-visible="15"
              />
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
  import Search from '@/components/Search'
  import CMS from '@/model/cms'
  import { mapMutations } from 'vuex'
  import SearchModel from '@/model/search'
  import {Trans} from "@/plugins/Translation"

  export default {
    components: {
      Search
    },
    data: () => ({
      menu: null,
      breadcrumbs: [],
      data: [],
      search: {},
      region: {},
      orderBy: 'publishDate',
      orderDir: 'desc',
      initiatorData: {},
      totalCount: 0,
      result: [],
      page: 1,
      commentsCnt: [],
      answersCnt: [],
      showBlock: false,
      paginationData: {},
      title: '',
      description: '',
      keywords: ''
    }),
    watch: {
      '$route.params.slug' () {
        this.search = {};
        this.region = {};
        this.fetchData()
        this.clearSort()
      },
      page () {
        this.fetchData(false)
      }
    },
    computed: {
      initiatorLabel() {
        if (this.$route.params.slug === 'zakonoproekty') {
          return 'Субъект законодательной инициативы'
        }

        return 'Инициатор проекта НПА'
      },
      initiatorItems() {
        if (this.$route.params.slug === 'zakonoproekty') {
          return this.data.refLawProjectInitiator || []
        }

        if (this.$route.params.slug === 'proekty-podzakonnykh-aktov') {
          return this.data.refSubordinateActProjectInitiator || []
        }

        return this.data.refInitiator || []
      }
    },
    metaInfo () {
      return {
        title: this.title,
        meta: [{
          vmid: 'description',
          name: 'description',
          content: this.description,
        }, {
          vmid: 'keywords',
          name: 'keywords',
          content: this.keywords,
        }]
      }
    },
    mounted () {
      this.fetchData()
    },
    created() {
      this.scrollToTop()
    },
    methods: {
      ...mapMutations(['setLoading']),
      getInitiatorRefKeys() {
        if (this.$route.params.slug === 'zakonoproekty') {
          return ['refLawProjectInitiator']
        }

        if (this.$route.params.slug === 'proekty-podzakonnykh-aktov') {
          return ['refSubordinateActProjectInitiator']
        }

        return ['refInitiator']
      },
      fetchData (reset = true) {
        this.setLoading(true)
        CMS.loadMenuBySlug(this.$route.params.slug)
          .then((response) => {
            this.breadcrumbs = [
              {
                text: this.$i18n.t('Главная'),
                disabled: false,
                href: Trans.currentLocaleUrl + '/'
              }
            ]
            this.menu = response.data
            this.npa_view_type = this.menu.npa_view_type.id
            if (this.menu) {
              const breadcrumb = {}
              breadcrumb.text = this.menu.transTitle
              breadcrumb.disabled = true
              this.breadcrumbs.push(breadcrumb)
              this.title = this.menu.transTitleSeo
              this.description = this.menu.transDescription
              this.keywords = this.menu.transKeywords
            }
            this.setLoading(false)
            CMS.getNpaData(['refDefaultInitiator', ...this.getInitiatorRefKeys()])
              .then((response) => {
                this.data = response.data
                this.initiatorData = this.search.initiator
                  ? this.search.initiator
                  : this.data.refDefaultInitiator
                if (this.menu.npa_view_type) {
                  if (this.menu.npa_view_type.id === 1) {
                    this.searchNPA(
                      this.initiatorData.id,
                      this.initiatorData.transName,
                      this.menu.npa_view_type.id,
                      reset
                    )
                  }
                  if (this.menu.npa_view_type.id === 2) {
                    this.searchNPA(null, '', this.menu.npa_view_type.id, reset)
                  }
                  if (this.menu.npa_view_type.id === 3) {
                    this.searchNPA(
                      7,
                      this.initiatorData.transName,
                      1,
                      reset
                    )
                  }
                }
                this.setLoading(false)
              })
              .catch((error) => {
                //console.log(error)
              })
          })
          .catch((error) => {
            //console.log(error)
          })
      },
      sortData(sortKey) {
        if (this.orderBy !== sortKey) {
          this.orderDir = 'desc'
        } else {
          if (this.orderDir === 'desc') {
            this.orderDir = 'asc'
          } else {
            this.orderDir = 'desc'
          }
        }
        this.orderBy = sortKey
        this.page = 1
        this.fetchData(true)
      },
      clearSort () {
        this.orderBy = 'publishDate'
        this.orderDir = 'desc'
        this.search.orderBy = this.orderBy
        this.search.orderDir = this.orderDir
      },
      searchNPA (id, name, type, reset = true) {
        if (type === 1) {
          delete this.search.view
          if (id) {
            this.search.initiator = id
          }
        } else if (type === 2) {
          delete this.search.initiator
          if (id) {
            this.search.view = id
          }
          if (this.region && this.region.id) {
            this.search.region = this.region.id;
          }
        } else if (type === 3) {
          this.search.initiator = 7
          if (id) {
            this.search.view = id
          }
        }
        if (reset === true) {
          this.page = 1
        }
        this.search.page = this.page
        this.search.orderBy = this.orderBy
        this.search.orderDir = this.orderDir
        this.search.viewType = type
        this.setLoading(true)

        SearchModel.search(this.search).then((response) => {
          this.result = response.data.items
          this.paginationData = response.data.paginationData
          this.commentsCnt = response.data.commentsCnt
          this.answersCnt = response.data.answersCnt

          this.breadcrumbs = [
            {
              text: this.$i18n.t('Главная'),
              disabled: false,
              href: Trans.currentLocaleUrl + '/'
            },
            {
              text: this.menu.transTitle,
              disabled: false,
              href: Trans.currentLocaleUrl + '/npa/' + this.menu.slug
            },
            {
              text: name,
              disabled: true
            }
          ]
          this.setLoading(false)
        })
        .catch((error) => {
          console.log(error)
        })
      },
      scrollToTop() {
        window.scrollTo(0, 0)
      }
    }
  }
</script>

<style>
.text-white {
  color: white!important;
}
</style>
